import Vue from 'vue'

export enum Weekdays {
  monday = 'Понедельник',
  tuesday = 'Вторник',
  wednesday = 'Среда',
  thursday = 'Четверг',
  friday = 'Пятница',
  saturday = 'Суббота',
  sunday = 'Воскресенье',
  lunch = 'Обед'
}

enum SortedWeekdays {
  monday,
  tuesday,
  wednesday,
  thursday,
  friday,
  // lunch before weekend
  lunch,
  saturday,
  sunday,
}

interface Weekday {
  active: boolean,
  openingHours: string,
  closingHours: string
}

type WeekdayOrigin = Record<keyof typeof SortedWeekdays, Weekday>

export default Vue.extend({
  data () {
    return {
      Weekdays,
      SortedWeekdays
    }
  },
  methods: {
    parseHours (hours: string, useMerge: boolean) {
      const hoursMap = Object.entries<Weekday>(JSON?.parse(hours || '{}') as WeekdayOrigin)?.sort((e1, e2) => this.SortedWeekdays[e1[0]] - this.SortedWeekdays[e2[0]])

      if (!(useMerge)) {
        return hoursMap.map((item) => {
          return { ...item[1], name: Weekdays[item[0]] }
        })
      }

      let key

      const groupedHours = (hoursMap)?.reduce((acc, curr) => {
        key = `${curr[1].openingHours}${curr[1].closingHours}${curr[1].active}${curr[0] === 'lunch'}`
        acc[key] = acc[key] || []
        acc[key].push({ ...curr[1], name: Weekdays[curr[0]] })
        return acc
      }, {})

      const result = Object.values(groupedHours).map((group: any, _idx) => {
        switch (group.length) {
          case 1:
            return group[0]
          case 2:
            return {
              active: group[0]?.active ?? false,
              openingHours: group[0].openingHours,
              closingHours: group[0].closingHours,
              name: `${group[0].name} и ${group[1].name}`
            }
          default:
            return {
              active: group[0]?.active ?? false,
              openingHours: group[0].openingHours,
              closingHours: group[0].closingHours,
              name: `${group[0].name} - ${group[group.length - 1].name}`
            }
        }
      })

      return result
    }
  }
})
